import { Button } from '@/components/shadcn/button';
import { Skeleton } from '@/components/shadcn/skeleton';
import PadelSubpageHeader from '@/components/community/padel/PadelSubpageHeader';
import PadelTimerPanel from '@/components/community/padel/PadelTimerPanel';
import PadelScorePad from '@/components/community/padel/PadelScorePad';
import PadelEditSkorFooter from '@/components/community/padel/PadelEditSkorFooter';
import PadelMatchNamesBar from '@/components/community/padel/PadelMatchNamesBar';
import { PADEL_SET_PICKER_MAX } from '@/components/community/padel/padelScoringUtils';
import { displayTimerMs, formatTimerMmSs } from '@/components/community/padel/padelTimerUtils';
import { usePadelEditSkor } from '@/pages/community/usePadelEditSkor';

export default function PadelEditSkorPage() {
  const skor = usePadelEditSkor();

  if (skor.loading) {
    return (
      <div className="px-4 py-6">
        <Skeleton className="h-40 w-full rounded-2xl" />
      </div>
    );
  }
  if (!skor.game) {
    return (
      <div className="px-4 py-10 text-center">
        <p className="text-gray-600">{skor.errorMessage || 'Game tidak ditemukan'}</p>
        <Button className="mt-4" onClick={skor.goBack}>
          Kembali
        </Button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-lg px-4 pb-28">
      <PadelSubpageHeader
        title={`Edit Skor · Game ${skor.gameNumber}`}
        onBack={skor.goBack}
      />
      <PadelMatchNamesBar
        sideA={skor.game.sideAPlayers.map((p) => p.playerName).join(' / ') || 'Sisi A'}
        sideB={skor.game.sideBPlayers.map((p) => p.playerName).join(' / ') || 'Sisi B'}
        center={skor.isPoints ? 'vs' : `${skor.winsA} - ${skor.winsB}`}
      />
      <PadelTimerPanel
        display={formatTimerMmSs(
          displayTimerMs(skor.game, skor.isPoints ? 1 : skor.activeSet, skor.now, skor.receivedAt)
        )}
        running={Boolean(skor.running)}
        onReset={() => void skor.patchTimer('reset')}
      />
      <PadelScorePad
        maxSets={skor.maxSets}
        activeSet={skor.activeSet}
        sets={skor.sets}
        current={
          skor.isPoints
            ? { setNumber: 1, scoreSideA: skor.scoreA, scoreSideB: skor.scoreB }
            : skor.current
        }
        pickerTarget={skor.isPoints ? skor.target : PADEL_SET_PICKER_MAX}
        americanoMode={skor.isPoints}
        hint={
          skor.isPoints
            ? `Total rally harus ${skor.target}. Tap angka untuk pilih poin akhir.`
            : 'Poin tenis 0 ➔ 15 ➔ 30 ➔ 40 ➔ Game. Tim dengan game terbanyak memenangkan set & masuk klasemen.'
        }
        onSelectSet={skor.setActiveSet}
        onBump={skor.bump}
        onSetScore={skor.setAbsoluteScore}
        rallyState={skor.rallyState}
        onAddRallyPoint={skor.addRallyPoint}
        onUndoRallyPoint={skor.undoRallyPoint}
        canUndo={skor.canUndo}
        manualEntry={skor.manualEntry}
        onToggleManualEntry={skor.setManualEntry}
        sideAName={skor.game.sideAPlayers.map((p) => p.playerName).join(' / ') || 'Tim A'}
        sideBName={skor.game.sideBPlayers.map((p) => p.playerName).join(' / ') || 'Tim B'}
        deuceEnabled={skor.deuceEnabled}
        onToggleDeuce={skor.toggleDeuce}
      />
      {skor.errorMessage && <p className="mt-3 text-sm text-red-500">{skor.errorMessage}</p>}
      <PadelEditSkorFooter
        running={Boolean(skor.running)}
        saving={skor.saving}
        onToggleTimer={() => void skor.patchTimer(skor.running ? 'pause' : 'start')}
        onSave={() => void skor.handleSave()}
      />
    </div>
  );
}
